import './LoadingBlock.scoped.scss';

export default function LoadingBlock({ title, isShow }: { title: string; isShow: boolean }): JSX.Element {
  return (
    <div
      className={[
        'fixed',
        'top-0',
        'left-0',
        'right-0',
        'bottom-0',
        'w-screen',
        'h-full',
        'z-50',
        'bg-black',
        'bg-opacity-60',
        'flex-col',
        'items-center',
        'justify-center',
        isShow ? 'flex' : 'hidden',
      ].join(' ')}
    >
      <div className="loader w-12 h-12"></div>
      <div className="N_14_R text-white mt-8">{title}</div>
    </div>
  );
}
